"use strict";
/**
 * @class SVGSquareBadge
 * @description Square badge svg
 */
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BadgeLabel_1 = require("./BadgeLabel");
var SVGSquareBadge = function (_a) {
    var text = _a.text;
    return (React.createElement("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", className: "oui__badge-square" },
        React.createElement("rect", { width: "100", height: "100" }),
        React.createElement(BadgeLabel_1.default, { text: text })));
};
exports.default = SVGSquareBadge;
//# sourceMappingURL=SVGSquareBadge.js.map